import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminRoute extends Route {
  // Services
  @service abilities;
  @service breadcrumb;
  @service currentUser;
  @service intl;
  @service permission;
  @service router;
  @service session;

  // Hooks
  async beforeModel(transition) {
    await this.session.requireAuthentication(transition, 'login');
    await Promise.all([
      this.currentUser.ensureReady(),
      this.permission.ensureReady(),
    ]);
    await this.checkUserPermissions(transition);

    this.router.on('routeWillChange', this.checkUserPermissions);
    this.router.on('routeWillChange', this.breadcrumb.checkRoutesToRollback);
    this.router.on(
      'routeDidChange',
      this.breadcrumb.checkTransitionAfterRollback,
    );
  }

  // Actions
  checkUserPermissions = async (transition) => {
    if (this.abilities.cannotAccess(transition)) {
      transition.abort();
      this.intermediateTransitionTo('admin.error', {
        errors: [
          {
            status: 403,
            title: this.intl.t('error.error_403.title'),
            detail: this.intl.t('error.error_403.detail'),
          },
        ],
      });
    }
  };

  // In native-class routes, Ember only treats methods decorated with @action
  // as route events. The error event that fires when a model hook
  // rejects is one of those. So it needs the @action decoartor.
  @action
  error(error) {
    if (
      error?.status == '401' ||
      error?.errors?.some((error) => error.status == '401')
    ) {
      return this.session.invalidate();
    } else {
      return true;
    }
  }
}
